/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

import { d } from './_utils';

import { commonProp7 } from './commonProp7';
import { commonProp5 } from './commonProp5';
import { commonProp6 } from './commonProp6';
import { commonProp4 } from './commonProp4';

export const leggings_jeggings : {[key: string]: Array<[string, string]>} = {
    p_type: [
        ["LEGGINGS", "Leg\u00edny"],
        ["JEGGINGS", "D\u017eeg\u00edny"],
    ],
    p_size: commonProp7,
    p_sex: commonProp5,
    p_brand: commonProp6,
    p_color: commonProp4,
};
